import { render, staticRenderFns } from "./ClientEmailNotificationFormCheckinInstructions.vue?vue&type=template&id=35dd5b88&"
import script from "./ClientEmailNotificationFormCheckinInstructions.vue?vue&type=script&lang=js&"
export * from "./ClientEmailNotificationFormCheckinInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports